import Alpine from 'alpinejs';
import ajax from '@imacrayon/alpine-ajax';
import focus from '@alpinejs/focus';
import htmx from 'htmx.org';

import baseScripts from './base-scripts';
import barrowsScrollbar from './barrows-scrollbar';

// Register Alpine plugins
Alpine.plugin(ajax);
Alpine.plugin(focus);

window.Alpine = Alpine;
window.htmx = htmx;

Alpine.data("baseScripts", baseScripts);
Alpine.data("barrowsScrollbar", barrowsScrollbar);

// Configure Alpine AJAX with WordPress nonce
document.addEventListener('alpine:init', () => {
    const wpNonce = window.wpApiSettings?.nonce || window.nonce;
    
    if (wpNonce) {
        // Configure Alpine AJAX headers
        Alpine.store('ajax', {
            headers: {
                'X-WP-Nonce': wpNonce,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    }
});

// Configure HTMX if nonce is available
const wpNonce = window.wpApiSettings?.nonce || window.nonce;
if(wpNonce) {
    document.addEventListener('htmx:configRequest', function(event) {
        event.detail.headers['X-WP-Nonce'] = wpNonce;
    });
}

document.addEventListener('DOMContentLoaded', function() {
    Alpine.start();
});

// GTM: fire formSubmission on Gravity Forms AJAX submit
if (window.jQuery) {
    jQuery(document).on('gform_confirmation_loaded', function (e, formId) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'formSubmission', formId: formId });
    });
}

// Alpine.magic('blockData', (el, { Alpine }) => {
//     // el.parentElement.id is the key of the blockData object
//     let blockData = Alpine.store('blockData')[el.parentElement.id];
//     return blockData;
// });